import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GrpcNode } from '@xprojectorcore/xprojector_backend/proto/xprojector.grpc.models.pb';
import { GrpcDoubleProperty, GrpcNodeType, GrpcStringProperty } from '@xprojectorcore/xprojector_backend/proto/xprojector.xconf.pb';
import { XProjectorXConfClient } from '@xprojectorcore/xprojector_backend/xprojector-xconf-client';
import { ArrayUtils, Guid } from 'xproj-lib';

@Component({
  selector: 'app-select-node-input',
  templateUrl: './select-node-input.component.html',
  styleUrls: ['./select-node-input.component.scss']
})
export class SelectNodeInputComponent implements OnInit {

  @Input() selectNodeProperty: GrpcStringProperty | GrpcDoubleProperty;

  @Input() nodeTypes: GrpcNodeType[] = [];
  @Input() value: string|number;
  @Input() customerId: string;
  @Output() valueChange = new EventEmitter<string|number>();


  @Input() showHelp: boolean = true;

  selectedNode: GrpcNode;
  selectedNodeName : string = 'Select...';

  id: string = Guid.newGuid();

  doubleProperty : GrpcDoubleProperty;
  stringProperty : GrpcStringProperty;
  showSelectNodeModal : boolean = false;

  constructor(
    private xConfClient: XProjectorXConfClient
  ) { }


  async ngOnInit() {
    if (this.selectNodeProperty.typeName == 'double') {
      this.doubleProperty = this.selectNodeProperty as GrpcDoubleProperty;
    }
    else if (this.selectNodeProperty.typeName == 'string') {
      this.stringProperty = this.selectNodeProperty as GrpcStringProperty;
    }
  }

  async ngAfterViewInit() {
    if ((this.doubleProperty && this.value as number > 0) || (this.stringProperty && (this.value as string)?.length > 0 )) {
      this.selectedNode = await this.xConfClient.getNode(this.value + "", this.selectNodeProperty.selectNodeNodeLabel)
      this.selectedNodeName = await this.getNodeDisplayName(this.selectedNode);
    }
  }

  async selectedValueChange($event) {
    this.valueChange.next(this.value);
  }

  clearValue() {
    if (this.doubleProperty) {
      this.value = 0;
    }
    else if (this.stringProperty) {
      this.value = '';
    }
    this.selectedNode = null;
    this.selectedNodeName = 'Select...';
    this.valueChange.next(this.value);
  }

  getNodeDisplayNameCallback = (node: GrpcNode) => {
    return this.getNodeDisplayName(node);
  }

  async onSelectNode(node: GrpcNode) {
    if (node && node.nodeTypeLabel == this.selectNodeProperty.selectNodeNodeLabel) {
      this.selectedNode = node;
      this.selectedNodeName = await this.getNodeDisplayName(this.selectedNode);
      if (this.doubleProperty) {
        this.value = +node.id;
      }
      else if (this.stringProperty) {
        this.value = node.id;
      }

      this.valueChange.next(this.value);
    }
  }

  showSelectNode() {
    this.showSelectNodeModal = true;
  }

  async getNodeDisplayName(node: GrpcNode): Promise<string> {
    if (node) {
      let nodeType = this.nodeTypes.find(n => n.id == node.nodeTypeId);
      if (nodeType && nodeType.namePropertyId?.length > 0) {
        let result: string[] = [];
        let namePropertyIds = nodeType.namePropertyId.split(',');

        await ArrayUtils.AsyncForEach(namePropertyIds, async (namePropertyId) => {
          if (namePropertyId == 'name') {
            result.push(node.name);
          }
          else {
            let propValue = node.propertyValues.find(v => v.key == namePropertyId);
            if (propValue) {
              let p = nodeType.stringProperties.find(strprop => strprop.id == nodeType.namePropertyId);
              if (propValue.value?.length > 0) {
                result.push(propValue.value);
              }
            }
          }
        });

        if (result.length > 0) {
          return Promise.resolve(nodeType.namePrefix + result.join(', '));
        }
      }

      return Promise.resolve(node.name || node.id);
    }

    return Promise.resolve("");
  }
}
